export const LBX_GTM_TRACKING_VALUES = {
  componentName: {
    lbxYourExperience: 'lbx-your-experience',
    lbxStyleSelector: 'lbx-style-selector',
    lbxExperienceHeader: 'lbx-experience-header',
    lbxExperienceExtraordinaryVideo: 'lbx-experience-extraordinary-video',
    lbxExperienceExtraordinaryImage: 'lbx-experience-extraordinary-image',
    lbxExperienceCollection: 'lbx-experience-collection',
    lbxExperienceMatchStyle: 'lbx-experience-match-style',
    lbxExperienceAiExperience: 'lbx-experience-ai-experience',
    lbxExperienceStory: 'lbx-experience-story',
    lbxExperienceLookingMore: 'lbx-experience-looking-more',
    lbxExperienceExploreInspiration: 'lbx-experience-explore-inspiration',
    lbxExperienceReserveToday: 'lbx-experience-reserve-today',
    lbxYourGallery: 'lbx-your-gallery',
    lbxInspiration: 'lbx-inspiration',
  },
  action: {
    backToLbxExperience: 'back-to-lbx-experience'
  },
  label: {    
    lbxPersonality: 'personality',
    lbxArtStyle: 'art-style',
    lbxTexture: 'texture',
    lbxWhyExperience: 'why-lbx-experience',
    createNewLbx: 'create-new-lbx'
  }
};